import React from 'react';
import { BrandsAPI } from '../../../../constructs/brands/interface';
import { useAPIContext } from '../../context/api';
import { triggerBrowserDownload } from './lib/trigger-browser-download';

export const useDownloadMedia = () => {
  const { callEndpoint } = useAPIContext();

  const downloadBannerZip = React.useCallback(
    async (bannerId: string) => {
      const response = await callEndpoint<BrandsAPI, 'download-banner-zip'>(
        'brands',
        `/banners/${bannerId}/download`,
        'GET'
      );

      triggerBrowserDownload(response.downloadUrl, `${bannerId}.zip`);

      return response;
    },
    [callEndpoint]
  );

  return { downloadBannerZip };
};
